export class VideoMetadata
{
    public videoTitle : String = null;
	public ytTtile: String = null;
	public videoDescription : String = null;
	public ytDescription : String = null;
	public keywords : Array<String>;
	public topics : Array<String>;
	public videoGenre : String = null;
	public videoSubGenre : String = null;
	public videoCategory : String = null;
	public videoLanguage : String = null;
	public primaryChannel : String = null;
	public secondaryChannels : Array<String>;
	public playlists : Array<String>;
	public unlisted: Boolean;
	public ytUpload:boolean = true;
	public saranyuUpload:boolean = true;
}